import { css, keyframes } from "@emotion/react";
import { styled } from "@mui/material";

const spin = keyframes({
  from: {
    transform: "translateY(-50%) rotate(0deg)",
  },

  to: {
    transform: "translateY(-50%) rotate(360deg)",
  },
});

export const StyledContent = styled("div")(
  ({ theme: { palette } }) => ({
    borderRadius: "50%",
    border: `${10} solid ${palette.custom.orange[300]}`,
    borderTopColor: "transparent",
    height: 60,
    left: 0,
    marginInline: "auto",
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    width: 60,
  }),
  css`
    animation: ${spin} 0.5s linear infinite;
  `,
);
